<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="565px" :before-close="closeModal">
    <AlertExclamationRegister size="40" color="#FFAC00" class="d-flex mt-5 mb-2 mx-auto"/>
    <h3 class="c-ndarkthree bold text-center mb-2 mt-3">
        A alteração deve levar algum tempo
        <br>para refletir no sistema
    </h3>
    <p class="c-ndarkfour text-center">
        Não se preocupe, a alteração será efetivada em até <span class="bold">4 horas.</span>
    </p>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <button :class="`btn btn-${getPrimaryColor}`" @click="closeModal">
            Entendi
        </button>
    </span>
</el-dialog>
</template>

<script>
import AlertExclamationRegister from '@/components/icons/AlertExclamationRegister'
export default {
    components: {
      AlertExclamationRegister
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
    },
    data() {
        return {}
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
    },
}
</script>

<style scoped>

</style>